import { Input } from '@angular/core';
import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { SkillDetailItem } from '../../models/SaidEvent';

@Component({
    templateUrl: './said-event-skill-details.component.html'
})
export class SaidEventSkillDetailsComponent {
    constructor(private activeModal: NgbActiveModal) {}

    @Input() set data(value: { details: SkillDetailItem[] }) {
        this.details = value.details.filter(d => d.Label.toLowerCase() != "header");
    }

    details: SkillDetailItem[] = [];

    close() {
        this.activeModal.dismiss();
    }
}
